import React from "react";
import { Link } from "react-router-dom";
import ExportToExcel from "../../../Utils/ExportCsv";
import { f_time } from "../../../Utils/Date_formet";

const Content = ({
  Page_title,
  button_status,
  button_title,
  Page_title_showClient,
  show_csv_button,
  show_Stat_End_date,
  showEdit,
  csv_title,
  csv_data,
  route,
  OpenModal,
  ...rest
}) => {
  return (
    <div className="content-body">
      <div className=" container-fluid px-0">
        <div className="wrapper-data">
          <div className="page-titles">
            <ol className="breadcrumb justify-content-between">
              <div
                className={`${
                  button_status !== false && button_title !== "Back"
                    ? "col-lg-6 col-7"
                    : "col-12"
                }`}
              >
                <li className="breadcrumb-item justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    {button_status !== false && button_title === "Back" && (
                      <Link to={route}>
                        <i className="fa-solid fa-arrow-left-long fs-4 fw-normal me-1 back-arrow"></i>
                      </Link>
                    )}

                    <h3 className="font-w500 mb-1 mb-0">{Page_title}</h3>
                  </div>

                  <h6 className="font-w500 subtitle">
                    {Page_title_showClient}
                  </h6>
                </li>
              </div>

              {/* Right button (Add, etc.) */}
              {button_status !== false && button_title !== "Back" && (
                <div className="col-lg-6 col-5">
                  <Link to={route} className="btn btn-sm btn-primary float-end">
                    <i className="fa-solid fa-plus"></i> {button_title}
                  </Link>
                </div>
              )}
            </ol>
          </div>

          <div className="">
            {showEdit ? (
              <>
                <div className=" d-flex">
                  <p className="">
                    Start Date -{" "}
                    {f_time(
                      show_Stat_End_date.StartDate !== undefined &&
                        show_Stat_End_date.StartDate
                    )}
                  </p>
                  <p className="ms-2">|</p>
                  <p className="ps-2">
                    End Date -{" "}
                    {f_time(
                      show_Stat_End_date.EndDate !== undefined &&
                        show_Stat_End_date.EndDate
                    )}
                  </p>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="card-body">
              {show_csv_button && (
                <ExportToExcel
                  className="btn btn-primary export-btn "
                  apiData={csv_data}
                  fileName={csv_title}
                />
              )}

              <div className="form-validation">{rest.children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
